import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    label: { default: '' },
    placeholder: { default: '' },
    modelValue: {},
    autocomplete: { default: '' },
    inputmode: { default: '' },
    name: { default: '' },
    maxLength: { default: -1 },
    disabled: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    type: { default: 'text' },
    error: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_md_outlined_text_field = _resolveComponent("md-outlined-text-field")!
  const _component_md_filled_text_field = _resolveComponent("md-filled-text-field")!

  return (__props.outlined)
    ? (_openBlock(), _createBlock(_component_md_outlined_text_field, {
        key: 0,
        class: _normalizeClass({ 'error-field': props.error }),
        label: props.label,
        value: props.modelValue,
        disabled: props.disabled,
        type: props.type,
        autocomplete: props.autocomplete,
        name: props.name,
        inputmode: props.inputmode,
        error: props.error,
        onChange: _cache[0] || (_cache[0] = e => emit('change', e)),
        onInput: _cache[1] || (_cache[1] = 
      e => emit('update:modelValue', e.target.value)
    )
      }, null, 8, ["class", "label", "value", "disabled", "type", "autocomplete", "name", "inputmode", "error"]))
    : (_openBlock(), _createBlock(_component_md_filled_text_field, {
        key: 1,
        class: _normalizeClass({ 'error-field': props.error }),
        label: props.label,
        placeholder: props.placeholder,
        value: props.modelValue,
        disabled: props.disabled,
        type: props.type,
        autocomplete: props.autocomplete,
        name: props.name,
        inputmode: props.inputmode,
        maxLength: props.maxLength,
        error: props.error,
        "supporting-text": "",
        onChange: _cache[2] || (_cache[2] = e => emit('change', e)),
        onInput: _cache[3] || (_cache[3] = 
      e => emit('update:modelValue', e.target.value)
    )
      }, null, 8, ["class", "label", "placeholder", "value", "disabled", "type", "autocomplete", "name", "inputmode", "maxLength", "error"]))
}
}

})